export default __webpack_public_path__ + "media/images/landlords_page/benefits_2-edd2db8e026c208f6025f2d2de467ad3.png";